import React from 'react';
import { useDispatch } from 'react-redux';
import type { Claim } from '../api/claims/interface';
import { useSelector } from '../data/store';
import { actions as claimOverviewActions } from './ClaimOverview/data/logic';

/**
 * Reads the cached claim from the claim-overview slice and dispatches a
 * fetch only when this dossier hasn't been cached yet. Revisiting a dossier
 * the user already saw is a state read — no network request.
 */
export function useClaim(dossierId: string | null): Claim | null {
  const dispatch = useDispatch();
  const claim = useSelector((s) =>
    dossierId ? s['claim-overview'].claimMetadata[dossierId] ?? null : null
  );
  const hasClaim = useSelector((s) =>
    dossierId
      ? s['claim-overview'].claimMetadata[dossierId] !== undefined
      : false
  );

  const dispatchedForRef = React.useRef<string | null>(null);
  React.useEffect(() => {
    if (!dossierId || hasClaim || dispatchedForRef.current === dossierId) {
      return;
    }
    dispatchedForRef.current = dossierId;
    dispatch(claimOverviewActions.fetchClaim({ dossierId, stateDb: true }));
  }, [dossierId, hasClaim, dispatch]);

  return claim;
}
